<div class="programs" *ngIf="timeline_programs && timeline_programs.length" [ngClass]="{snapshot_view:snapshot_view, facilitator_view:facilitator_view}">
  <div class="event_header"[ngClass]="{ desktop: facilitator_view }">
    <div class="incrementor program_title desktop" *ngIf="facilitator_view">
      <button [disabled]="data.currentIndex==0" (click)="increment.emit(data.currentIndex-1)">
        <icon matIcon="keyboard_arrow_left"></icon>
      </button>
      <div class="title">{{title || 'Unnamed '+ uiService.programTerm.btn +'...'}}</div>
      <button [disabled]="data.currentIndex==programs.length-1" (click)="increment.emit(data.currentIndex+1)">
        <icon matIcon="keyboard_arrow_right"></icon>
      </button>
    </div>
    <div class="view_mode">
      <icon class="mobile" [ngClass]="{active: !!actualFilterCount }" (click)="filter.emit()" icon="filter_24px"></icon>
      <div style="flex:1"></div>
      <mat-progress-spinner class="desktop" diameter="24" mode="indeterminate" *ngIf="snapshot_loading"></mat-progress-spinner>

      <h5 class="menu desktop" [matMenuTriggerFor]="snapshot" *ngIf="showSnapshotMenu && ((!readonly && !event?.closed) || event?.snapshots?.length)" [ngClass]="{hasShot:event?.snapshots?.length}">
        <span>{{event?.snapshots?.length ? 'Snapshots' : '+ Save a snapshot'}}</span>
        <span class="down-arrow" *ngIf="event?.snapshots?.length"></span>
      </h5>
      <icon *ngIf="facilitator_view" [icon]="'grow'" (click)="$event.stopPropagation(); expandAll()"></icon>
      <icon *ngIf="facilitator_view" [icon]="'shrink'" (click)="$event.stopPropagation(); collapseAll()"></icon>
      <icon *ngIf="facilitator_view" (click)="uiService.print()" matIcon="print"></icon>
      <icon class="timelineMode" [ngClass]="{active: timelineMode == 'multiple'}" (click)="toggleView('multiple')" icon="column_multi_24px"></icon>
      <icon class="timelineMode" [ngClass]="{active: timelineMode == 'single'}" (click)="toggleView('single')" icon="column_single_24px"></icon>
      <icon *ngIf="!facilitator_view" [matMenuTriggerFor]="viewOptions" matIcon="more_vert"></icon>
      <icon *ngIf="facilitator_view" (click)="increment.emit(-1)" matIcon="close"></icon>

      <mat-menu #viewOptions="matMenu" xPosition="before">
        <div class="heading">VIEW</div>
        <button mat-menu-item [ngClass]="{active: detailedMode}" (click)="toggleDetails(true)">Detailed</button>
        <button mat-menu-item [ngClass]="{active:!detailedMode}" (click)="toggleDetails(false)">Condensed</button>
        <div>
          <hr />
          <div class="heading">ARRANGE</div>
          <button mat-menu-item [ngClass]="{active:timelineMode == 'multiple'}" (click)="toggleView('multiple')">Multi column</button>
          <button mat-menu-item [ngClass]="{active:timelineMode == 'single'}" (click)="toggleView('single')">Single column</button>
          <hr class="mobile" *ngIf="timelineMode=='multiple'" />
          <button mat-menu-item class="mobile" *ngIf="timelineMode=='multiple'" (click)="toggleAll('expand', 'programs')">Expand all programs</button>
          <button mat-menu-item class="mobile" *ngIf="timelineMode=='multiple'" (click)="toggleAll('collapse', 'programs')">Collapse all programs</button>
          <button mat-menu-item class="mobile" *ngIf="timelineMode=='multiple'" (click)="toggleAll('expand', 'days')">Expand all days</button>
          <button mat-menu-item class="mobile" *ngIf="timelineMode=='multiple'" (click)="toggleAll('collapse', 'days')">Collapse all days</button>
        </div>
      </mat-menu>
      <mat-menu #snapshot="matMenu" xPosition="before" class="snapshot_menus">
        <h5>SNAPSHOTS</h5>
        <div class="caption" *ngIf="!event?.snapshots || event?.snapshots?.length==0">No snapshots</div>
        <div mat-menu-item class="item" *ngFor="let shot of event?.snapshots" (click)="popupSnapshot(shot)">
          <div class="name">{{shot.name}}</div>
          <div class="time">{{shot.timestamp*1000 | date:'h:mma, EEE d MMM'}}</div>
        </div>
        <mat-progress-spinner *ngIf="snapshot_saving" [diameter]="25" mode="indeterminate" color="primary"></mat-progress-spinner>
        <button class="snap_item" *ngIf="!readonly && !event?.closed" (click)="takeSnapshot($event)">+ Save a snapshot</button>
      </mat-menu>
    </div>
  </div>
  <div *ngIf="facilitator_view && programEntities[timeline_programs[0].programId] as program" class="facilitator_header" > 
    <ng-content select=".notes-top"></ng-content>
    <div *ngIf="(program.venueId && event.venues[program.venueId]) || { venue: null, address: null } as venue" class="program" (click)="openProgramDetail(data.program_legend[program.id])">
      <div class="secondary_link">
        <div class="title underline_on_hover">{{program.title}}</div>
        <div class="facilitator-handle">
          <span class="underline_on_hover" [ngClass]="{waiting:!venue.venue}">{{venue.venue || 'Venue name'}} - </span>
          <span class="underline_on_hover" [ngClass]="{waiting:!program.location}">{{program.location || 'Venue Room/Location'}}</span>
        </div>
        <div class="facilitator-handle">
          <!-- <span class="underline_on_hover" [ngClass]="{waiting:!program.address}">{{ program.address }}</span> no program.address -->
          <span class="attachment hide_on_print" *ngIf="program.files && program.files.length>0">
            <icon class="attachment" matIcon="attachment"></icon>
            {{program.files.length}}
          </span>
        </div>
      </div>
      <div class="labels">
        <div class="labels_content" *ngIf="program.labels && program.labels.length > 0">
          <div *ngFor="let id of program.labels">
            <label-item *ngIf="labelMaps.program_labels && labelMaps.program_labels[id] as lbl" [color]="lbl.color" [label]="lbl.label"></label-item>
          </div>
        </div>
      </div>
    </div>
    <expanding-wrapper
      *ngIf="{ open: !collapsedStates[program.id + 'notes'] } as vars"
      class="facilitator_notes"
      [initOpen]="true"
      [borderGreyOnCollapse]="false"
      [expandedState]="!vars.open ? 'collapse' : 'expand'"
      [manualToggle]="true"
      [ngClass]="{collapse: !vars.open}"
      (onToggle)="collapsedStates[program.id + 'notes'] = vars.open"
    >
      <div class="header-left"><h4>Facilitator Notes</h4><icon [icon]="'DESCRIPTION18'"></icon></div>
      <input-editor 
        [disabled]="true"
        [object]="program" 
        [prop]="'facilitatorNotes'" 
        [placeholder]="readonly ? '' : 'Add notes...'"
        (click)="readonly ? null : editFacilitatorNotes.emit({ event: $event, programId: program.id, sessionId: undefined })"
      ></input-editor>
    </expanding-wrapper>
  </div>
  <expandable-bar-wrapper 
    *ngFor="let prog of timeline_programs; trackBy: trackByFn; index as idx; first as firstProgram"
    class="smooth"
    [ngClass]="{first: firstProgram}"
    [collapseObject]="timelineViews"
    [collapseStateId]="'' + idx"
    [header]="prog.date < 10000 ? 'Day ' + prog.date : prog.date | date:'EEEE d MMMM y'">
    <div class="program_content" [ngClass]="{hide_details:!detailedMode}">
      <!--Single column mode-->
      <div class="sessions single" *ngIf="timelineMode==='single'">
        <ng-container *ngFor="let session of prog.sessions | withLabels:data.filtered_by:'program_single'; trackBy: trackByFn; first as first; last as last; index as i">
          <div *ngIf="!session" class="not_found">No programs and sessions</div>
          <timeline-item *ngIf="session && { start: !!first ? session.start : { session: session, priorSession: prog.sessions[i-1] } | timelineStart } as svars"
            [start]="svars.start" 
            [hideDot]="!svars.start && !last"
            [end]="session.end"
            [timezoneAbbr]="session.timezoneAbbr"
            [duration]="session.duration"
            [printDate]="prog.date"
            [first]="first" 
            [last]="last" 
            [link]="true"
            [labelMaps]="labelMaps"
            [isBreak]="!!session['break']"
            [title]="session.title"
            [description]="detailedMode && session.description" 
            [labelMap]="detailedMode && labelMaps.session_labels || undefined" 
            [labelIds]="detailedMode && session.sess_labels" 
            [performers]="detailedMode && performers || {}" 
            [performerIds]="detailedMode && session.performerIds"
            [sponsors]="detailedMode && sponsors || {}"
            [sponsorIds]="detailedMode && session.sponsorIds"
            [publicLinks]="session.publicLinks"
            [programLine]="session.programText"
            [performerRoleIds]="session.performerRoleIds"
            [performerRoles]="performerRoles"
            [collapsible]="facilitator_view && detailedMode && !session.break"
            [timeAbove]="facilitator_view"
            [manualCollapse]="facilitator_view"
            [forcedCollapseState]="!detailedMode ? 'expand' : collapsedStates[session.sessionId] ? 'collapse' : 'expand'"
            (onToggleCollapse)="toggleExpanded(session.sessionId)"
            [narrowPerformersHeading]="facilitator_view || performerDisplayType === performerDisplayTypes.staticCardSmallHeader"
            [condensedPerformers]="false"
            

            (selectProgram)="openProgramDetail(data.program_legend[session.pID])"
            (selectItem)="openSessionDetail(session, prog, prog.date)">
            <expanding-wrapper
              *ngIf="facilitator_view && { open: !collapsedStates[session.sessionId + 'notes'] } as vars"
              class="facilitatorNotes info-bottom"
              [initOpen]="true"
              [borderGreyOnCollapse]="false"
              [expandedState]="!vars.open ? 'collapse' : 'expand'"
              [manualToggle]="true"
              [ngClass]="{collapse: !vars.open}"
              (onToggle)="collapsedStates[session.sessionId + 'notes'] = !collapsedStates[session.sessionId + 'notes']"
            >
              <div class="header-left"><h4>Facilitator Notes</h4><icon [icon]="'DESCRIPTION18'"></icon></div>
              <input-editor
                [disabled]="true"
                [object]="session" 
                [prop]="'facilitatorNotes'"
                [placeholder]="readonly ? '' : 'Add notes...'"
                (click)="readonly ? null : editFacilitatorNotes.emit({ event: $event, programId: session.pID, sessionId: session.sessionId })"
              ></input-editor>
            </expanding-wrapper>
          </timeline-item>
        </ng-container>
      </div>
      <!--Multiple column mode-->
      <div class="sessions multiple" *ngIf="timelineMode==='multiple'">
        <ng-container *ngFor="let p of prog.programs | withLabels:data.filtered_by:'program_multiple'; trackBy: trackByFn; index as s_idx;">
          <div *ngIf="!p" class="not_found">No programs and sessions</div>
          <multi-timeline-column *ngIf="p"
            [title]="p.title"
            [location]="p.location"
            [venue]="event.venues[p.venueId]?.venue || ''"
            [address]="event.venues[p.venueId]?.address || ''"
            [programLabels]="p.prog_labels"
            [labelTemplate]="label_template.program"
            [collapseObject]="timelineViews"
            [collapseStateId]="idx + '_' + s_idx"
            [detailedMode]="detailedMode"
            (openProgram)="openProgramDetail(data.program_legend[p.pID])"
          ><ng-container *ngFor="let session of p.sessions | withLabels:data.filtered_by:'session'; trackBy: trackByFn; first as first; last as last; index as i">
              <div *ngIf="!session" class="not_found">No programs and sessions</div>
              <timeline-item *ngIf="session && { start: !!first ? session.start : { session: session, priorSession: p.sessions[i-1] } | timelineStart } as svars"  
                [start]="svars.start" 
                [hideDot]="!svars.start && !last"
                [end]="session.end"
                [timezoneAbbr]="session.timezoneAbbr"
                [duration]="session.duration"
                [printDate]="prog.date"
                [first]="first" 
                [last]="last" 
                [link]="true"
                [title]="session.title" 
                [description]="detailedMode && session.description" 
                [labelMap]="detailedMode && labelMaps.session_labels || {}"
                [labelMaps]="labelMaps"
                [labelIds]="detailedMode && session.sess_labels" 
                [performers]="detailedMode && performers || {}" 
                [performerIds]="detailedMode && session.performerIds"
                [performerRoleIds]="session.performerRoleIds"
                [performerRoles]="performerRoles"
                [publicLinks]="session.publicLinks"
                [sponsors]="detailedMode && sponsors || {}"
                [sponsorIds]="detailedMode && session.sponsorIds"
                [condensedPerformers]="!facilitator_view"
                (selectItem)="openSessionDetail(session, p, prog.date)">
              </timeline-item>
            </ng-container> <!-- end of session -->
          </multi-timeline-column>
        </ng-container>
      </div>
    </div>
  </expandable-bar-wrapper>
</div>